import React from "react";
import { Navigate, Outlet, useLocation } from "react-router-dom";
import { useAdminAuth } from "@/admin/AdminAuthContext";
import { Loader2 } from "lucide-react";

export default function AdminProtectedRoute() {
  const { user } = useAdminAuth();
  const location = useLocation();

  if (user === null) {
    return (
      <div className="min-h-screen bg-[#050507] text-white flex items-center justify-center">
        <Loader2 className="w-6 h-6 animate-spin text-white/40" />
      </div>
    );
  }
  if (user === false) {
    return <Navigate to="/admin/login" replace state={{ from: location }} />;
  }
  return <Outlet />;
}
